import '@tnn/ui/styles.css'
import { startApps } from '@tnn/app-kit'

// Every app is part of Thananan OS, under its own path (packages/core/src/apps.ts): only the one opened is loaded
startApps({
  portal: () => import('./app').then((m) => m.app),
  tms: () => import('@tnn/tms/app').then((m) => m.app),
  accounting: () => import('@tnn/accounting/app').then((m) => m.app),
  hr: () => import('@tnn/hr/app').then((m) => m.app),
  payroll: () => import('@tnn/payroll/app').then((m) => m.app),
  admin: () => import('@tnn/admin/app').then((m) => m.app),
  company: () => import('@tnn/company/app').then((m) => m.app),
  driver: () => import('@tnn/driver/app').then((m) => m.app),
  drive: () => import('@tnn/drive/app').then((m) => m.app),
  boards: () => import('@tnn/boards/app').then((m) => m.app),
})
